import * as React from 'react';
import { RoomsList as RoomsListComponent } from '../../components/RoomsList';
import { IResidentialComplexRoomsInfo } from '../../types/residentials';
import { getRooms, setStudioFirst } from './helpers';

interface IRoomsListProps {
  roomsInfo?: IResidentialComplexRoomsInfo[] | null;
}

export function RoomsList({ roomsInfo }: IRoomsListProps) {
  if (!roomsInfo) {
    return null;
  }

  const roomsWithStudioFirst = setStudioFirst(roomsInfo);
  const rooms = getRooms(roomsWithStudioFirst);

  return <RoomsListComponent rooms={rooms} />;
}
